<script setup lang="ts">
import { ref } from 'vue'

// Background class per tone. Add new tones here (e.g. for other surfaces) and the
// `tone` prop type updates automatically.
const TONE_CLASSES = {
  light: 'bg-gray-200',
  dark: 'bg-white/10',
} as const

const props = withDefaults(
  defineProps<{
    max?: number
    min?: number
    width?: string
    height?: string
    tone?: keyof typeof TONE_CLASSES
  }>(),
  {
    min: 64,
    max: 120,
    tone: 'light',
  },
)

const randomWidth = ref('')

if (props.width) {
  randomWidth.value = props.width
} else {
  const value = Math.floor(Math.random() * (props.max - props.min + 1) + props.min)
  randomWidth.value = `${value}px`
}
</script>

<template>
  <div
    class="inline-block animate-pulse"
    :class="[TONE_CLASSES[tone], height ? 'rounded-md' : 'h-2.5 rounded-full']"
    :style="{ width: randomWidth, height }"
  ></div>
</template>
